import React from "react";
import { Grid, Typography, MenuItem, Select } from "@mui/material";

const timeOptions = Array.from({ length: 26 }, (_, i) => {
  const hour = Math.floor(i / 2) + 9;
  const minute = i % 2 === 0 ? "00" : "30";
  const period = hour >= 12 ? "PM" : "AM";
  const displayHour = hour > 12 ? hour - 12 : hour;
  return `${displayHour}:${minute} ${period}`;
});

const CustomHoursSection = ({ hours, onChange }) => (
  <Grid item xs={12}>
    <Typography variant="subtitle1" fontWeight="bold" mt={2}>
      Custom Hours
    </Typography>
    {Object.keys(hours).map((day) => (
      <Grid container spacing={2} key={day} sx={{ mt: 1 }}>
        <Grid item xs={2}>
          <Typography variant="body2" sx={{ mt: 2 }}>
            {day.toUpperCase()}
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Select
            fullWidth
            displayEmpty
            value={hours[day].open}
            onChange={(e) => onChange(day, "open", e.target.value)}>
            <MenuItem value="">Closed</MenuItem>
            {timeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={5}>
          <Select
            fullWidth
            displayEmpty
            value={hours[day].close}
            onChange={(e) => onChange(day, "close", e.target.value)}>
            <MenuItem value="">Closed</MenuItem>
            {timeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
    ))}
  </Grid>
);

export default CustomHoursSection;
